import { render, staticRenderFns } from "./TransactionDeskCallback.vue?vue&type=template&id=673c0e0e&lang=pug"
import script from "./TransactionDeskCallback.vue?vue&type=script&lang=js"
export * from "./TransactionDeskCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports